import { Component, Directive, ContentChildren, QueryList } from "@angular/core";

// content slots

// slot / icon
@Directive({
  selector: 'summary-panel-icon'
})
export class SummaryPanelIconDirective {}

// slot / content
@Directive({
  selector: 'summary-panel-content'
})
export class SummaryPanelContentDirective {}

// slot / action
@Directive({
  selector: 'summary-panel-action'
})
export class SummaryPanelActionDirective {}

// component
@Component({
  selector: 'spark-summary-panel',
  styleUrls: ['./summary-panel.component.scss'],
  templateUrl: './summary-panel.component.html',
})
export class SummaryPanelComponent {

  @ContentChildren(SummaryPanelIconDirective, { descendants: false })
  iconContentChildren?: QueryList<SummaryPanelIconDirective>;

  @ContentChildren(SummaryPanelActionDirective, { descendants: false })
  actionContentChildren?: QueryList<SummaryPanelActionDirective>;

  public get hasIcon(): boolean {
    return !!this.iconContentChildren?.length;
  }

  public get hasAction(): boolean {
    return !!this.actionContentChildren?.length;
  }
}
